import React, {useState, useEffect} from "react";
import '../css/components/Section05.css';
import {useNavigate, Link}  from "react-router-dom"

const Section05: React.FC = () => {
    const navigate = useNavigate();

    const openTermsVisible = () => navigate('/pages/termsPage');

    const openPrivacyVisible = () => navigate('/pages/PrivacyPolicyPage');


    return (
        <div id="section05">
            <article className="footer">
                <div className="logo_btn">
                    <img src="/image/pudgy_logo3.png" alt="Footer Logo"/>
                </div>
                <div className="copy">
                    <Link to="/pages/termsPage" target="_blank" rel="noopener noreferrer">
                        Terms of Use
                    </Link>
                    <Link to="/pages/PrivacyPolicyPage" target="_blank" rel="noopener noreferrer">
                        Privacy Policy
                    </Link>
                    <p>
                        Daehong Communications Co., Ltd. (821-88-01030, CEO Kim Deok-hee, 10 Tongil-ro, Jung-gu,
                        Seoul)
                        <br/>
                        Mail order number 2018-Seoul Jung-gu-0681
                        <br/>
                        COPYRIGHT ⓒ 2024 DAEHONG COMMUNICATIONS INC. ALL RIGHTS RESERVED
                    </p>
                </div>
            </article>
        </div>
    );
};


export default Section05;
